import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./ServicePages.css";
import hero from "./assets/WebsiteUptime/website-uptime-monitoring-hero.png";
import value from "./assets/WebsiteUptime/website-for-accountants-secure-hosting.png";
import process from "./assets/WebsiteUptime/website-uptime-monitoring-dashboard.png";
import fourStep from "./assets/WebsiteUptime/website-uptime-monitoring-four-step-checklist.png";
import phone from "./assets/WebsiteUptime/attoli-free-uptime-check-call.png";
import Footer from "./Footer";

const WebsiteUptime = () => {
  return (
    <div className="page-wrapper">
      <Helmet>
        <meta
          name="description"
          content="Attoli sets up secure hosting and monitors your accounting firm website around the clock. Book a free call to check your current uptime today."
        />
        <title>Website Uptime Monitoring For Accountants | Attoli</title>
        <link
          rel="canonical"
          href="https://attoli.com/services/website-uptime-monitoring-for-accountants"
        />
      </Helmet>

      <div className="servicePage-container">
        <section className="servicePage-section hero-section">
          <div className="servicePage-content">
            <div className="servicePage-left">
              <h1 className="servicePage-title">
                Website Uptime Monitoring For{" "}
                <span className="hero-accent">Accountants</span>
              </h1>
              <p className="servicePage-description">
                Keep your site online and loading fast every single day. We set
                up secure hosting and watch your site around the clock so small
                problems never turn into missed calls.
              </p>

              <ul className="trust-badges">
                <li>No lock in contracts</li>
                <li>Built only for accounting and bookkeeping firms</li>
                <li>Free 20 minute call before you commit to anything</li>
              </ul>

              <div className="cta-block">
                <Link to="/contact" className="cta-button">
                  Book A Free Uptime Check
                </Link>
              </div>
            </div>

            <div className="servicePage-right">
              <img
                src={hero}
                alt="Laptop with a green checkmark status indicator over a website showing it is online and working correctly"
                className="servicePage-image"
              />
            </div>
          </div>
        </section>

        <section className="servicePage-section pain-section">
          <div className="section-inner">
            <h2 className="section-title">
              Why Website Uptime Monitoring Cannot Be An Afterthought
            </h2>
            <p className="body-copy">
              A website that goes down for even a few hours can quietly cost you
              clients. Someone searches for your firm finds a page that will not
              load and calls the next accountant on the list instead.
            </p>
            <p className="body-copy">
              Most accounting firms have no idea when their site goes down.
              Nobody is watching. The first sign of trouble may come from a
              client mentioning it weeks later.
            </p>
            <p className="body-copy">
              Cheap or outdated hosting makes this worse. Slow servers crash
              more often and take longer to recover. Without active monitoring
              in place downtime can sit unnoticed for hours or even days.
            </p>
            <p className="body-copy body-copy-emphasis">
              A site that stays online and loads fast protects the leads you
              already worked hard to earn.
            </p>
          </div>
        </section>

        <section className="servicePage-section value-section">
          <div className="section-inner">
            <h2 className="section-title">
              We Also Offer SEO Website Migration Services Include
            </h2>
            <p className="body-copy">
              Attoli sets up and manages the hosting and monitoring work most
              accounting firms never get around to. Here is what that looks like
              in practice.
            </p>

            <div className="value-grid">
              <div className="value-card">
                <h3>Secure Hosting Setup</h3>
                <p>
                  We set up hosting built for speed and security. A solid
                  hosting foundation keeps your site fast and protected from day
                  one.
                </p>
              </div>
              <div className="value-card">
                <h3>SEO Safe Website Migration</h3>
                <p>
                  We move your site to better hosting without losing your
                  rankings. Every redirect and setting gets checked so nothing
                  breaks in the process.
                </p>
              </div>

              <div className="value-card">
                <h3>24/7 Uptime Monitoring</h3>
                <p>
                  We watch your site around the clock and get alerted the moment
                  it goes down. Most issues get caught and fixed before a client
                  ever notices.
                </p>
              </div>
              <div className="value-card">
                <h3>Speed And Performance Checks</h3>
                <p>
                  We test your site regularly to catch anything slowing it down.
                  A fast site keeps visitors on the page instead of leaving.
                </p>
              </div>
              <div className="value-card">
                <h3>Monthly Reporting</h3>
                <p>
                  We send a simple monthly report showing your uptime speed and
                  any issues we fixed.
                </p>
              </div>
            </div>
            <img
              src={value}
              alt="Locked padlock icon over a website address bar representing secure hosting and an active SSL certificate"
              className="inline-image"
            />
          </div>
        </section>

        <section className="servicePage-section keyword-section">
          <div className="section-inner">
            <h2 className="section-title">
              What A Website For Accountants Needs To Stay Reliable
            </h2>
            <p className="body-copy">
              Your website is often the first place a potential client checks
              before calling. If it is slow or down that first impression is
              gone before you even know it happened.
            </p>

            <img
              src={process}
              alt="Dashboard with a green status light and the text online next to an alert bell icon representing active monitoring"
              className="inline-image"
            />

            <p className="body-copy">
              We monitor uptime the same way you track deadlines. Constantly and
              without exception. A missed filing date causes problems. A missed
              outage does too.
            </p>
          </div>
        </section>

        <section className="servicePage-section process-section">
          <div className="section-inner">
            <h2 className="section-title">
              How Our Website Hosting And Monitoring Process Works Step By Step
            </h2>

            <img
              src={fourStep}
              alt="Four step checklist for website uptime monitoring covering hosting setup uptime checks speed checks and reporting"
              className="inline-image"
            />

            <ul className="ledger-list">
              <li>
                <span className="ledger-number">01</span>
                <div>
                  <h3>Hosting Setup</h3>
                  <p>
                    We set up secure fast hosting built to handle your site and
                    its traffic.
                  </p>
                </div>
              </li>
              <li>
                <span className="ledger-number">02</span>
                <div>
                  <h3>Uptime Checks</h3>
                  <p>
                    We monitor your site around the clock to catch downtime the
                    moment it happens.
                  </p>
                </div>
              </li>
              <li>
                <span className="ledger-number">03</span>
                <div>
                  <h3>Speed Checks</h3>
                  <p>
                    We test load times regularly and fix anything slowing your
                    site down.
                  </p>
                </div>
              </li>
              <li>
                <span className="ledger-number">04</span>
                <div>
                  <h3>Monthly Reporting</h3>
                  <p>
                    We send a report every month showing your uptime speed and
                    any fixes made.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </section>

        <section className="servicePage-section faq-section">
          <div className="section-inner">
            <h2 className="section-title">Before You Book Your Call</h2>

            <details className="faq-item">
              <summary>What happens if my site goes down?</summary>
              <p>
                We get alerted immediately and start working on it right away.
                Most outages are resolved within hours.
              </p>
            </details>

            <details className="faq-item">
              <summary>Do I have to sign a long contract?</summary>
              <p>
                No. We work month to month. You stay because the results are
                working not because a contract locks you in.
              </p>
            </details>

            <details className="faq-item">
              <summary>
                Can you migrate my site without losing my rankings?
              </summary>
              <p>
                Yes. We follow a careful migration process that preserves your
                redirects and SEO setup so your rankings stay intact.
              </p>
            </details>

            <details className="faq-item">
              <summary>Do you work with other website builders?</summary>
              <p>
                Yes. We work with all major website builders includeing but not
                limited to, <strong>Squarespace, WordPress, and Wix</strong>. We
                also work with custom coded sites and can help you migrate to a
                better platform if needed.
              </p>
            </details>

            <details className="faq-item">
              <summary>Do I need to understand hosting myself?</summary>
              <p>
                No. We handle the setup the monitoring and the technical work.
                You get a simple report each month showing what happened.
              </p>
            </details>
          </div>
        </section>

        <section className="servicePage-section closer-section">
          <div className="section-inner closer-inner">
            <img
              src={phone}
              alt="Calendar with a call icon and the text free 20 minute call"
              className="inline-image closer-image"
            />

            <h2 className="section-title">
              Ready To Stop Worrying About Downtime?
            </h2>
            <p className="body-copy">
              Book a free 20 minute call. We will check your current hosting and
              uptime and show you exactly where you are at risk.
            </p>
            <Link to="/contact" className="cta-button cta-button-large">
              Book A Free Call Today
            </Link>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default WebsiteUptime;
